import { BehaviorSubject } from 'rxjs';

const eventSubject = new BehaviorSubject(null);

export const eventService = {
    eventSubject,
    event: eventSubject.asObservable(),
    get eventValue() { return eventSubject.value }
};

export * from './account.service';
export * from './alert.service';
export * from './i18n.service';